import _ from 'lodash';
import type { FacilityFullQuery, FacilityFullQueryVariables } from '@/shared/api';

import { createClient } from '@/shared/api';
import FACILITY_FULL_QUERY from '../queries/facilityFull';

/**
 * Loads the full record of a single facility. Runs the full facility query for the id and throws the first GraphQL error only when no facility came back.
 *
 * @param id - Identifier of the facility to load.
 * @returns A promise resolving to the full facility payload.
 */
const fetchFacility = async (id: any) => {
  const client = createClient();
  const result = await client.query<FacilityFullQuery, FacilityFullQueryVariables>({
    query: FACILITY_FULL_QUERY,
    variables: { id },
  });
  const { data, errors } = result;
  const { facility } = data;
  if (_.isNil(facility) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return facility;
};

export default fetchFacility;
